import axios from 'axios';
import { useQuery } from 'react-query';
import { baseUrl, tenant } from 'Shared/BaseUrl';

export default function useDetails() {


    return useQuery(
        ['details'],
        () => axios.get(baseUrl + `auth/get-details`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("ebs-client-token"),
                'X-Tenant': tenant,
            }
        })
    )


}